import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const getErrorMessage = (error, fallbackMsg) => {
  return error.response?.data?.message || error.message || fallbackMsg;
};

export const fetchKey = createAsyncThunk(
  "key/fetchKey",
  async (superAdminId, thunkAPI) => {
    try {

      // Check if userId exists before making API call
      if (!superAdminId) {
        return thunkAPI.rejectWithValue("User ID not found in session storage.");
      }

      const res = await axios.get(`https://payyug.in/api/apikey/list`, {
        params: {
          superAdminId,
        },
      });

      return  res.data?.data?.[0] ||res.data?.data || null;
    } catch (error) {
      const errorMsg = getErrorMessage(error, "Failed to fetch api key.");
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

const keySlice = createSlice({
  name: "key",
  initialState: {
    keyData: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Synchronous reducers can be added here if needed
    clearKeyState: (state) => {
      state.keyData = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKey.fulfilled, (state, action) => {
        state.loading = false;
        state.keyData = action.payload;
      })
      .addCase(fetchKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearKeyState } = keySlice.actions;
export default keySlice.reducer;